// extracted by mini-css-extract-plugin
export var aboveInput = "_kb-0";
export var actionButton = "_kb-5";
export var actionButtonContainer = "_kb-1";
export var actionIcon = "_kb-6";
export var aiInfoContainer = "_kb-2";
export var attachmentWrapper = "_kb-7";
export var bold = "_kb-3";
export var checkIcon = "_kb-8";
export var clickingRecipientBar = "_kb-11";
export var commentThreadSwitch = "_kb-a";
export var draftImage = "_kb-b";
export var draftImageContainer = "_kb-c";
export var draftImages = "_kb-e";
export var editButton = "_kb-g";
export var editor = "_kb-f";
export var editorContainer = "_kb-y";
export var editorErrorTooltipWrapper = "_kb-9";
export var headerDivider = "_kb-h";
export var icon = "_kb-i";
export var info = "_kb-j";
export var internal = "_kb-n";
export var internalDivider = "_kb-k";
export var internalMessage = "_kb-l";
export var messageInputCard = "_kb-m";
export var messageInputForm = "_kb-o";
export var messageInputFormInternal = "_kb-p";
export var options = "_kb-q";
export var publicMessageCustomer = "_kb-s";
export var publicMessageMerchant = "_kb-r";
export var removeImageButton = "_kb-d";
export var replyButtons = "_kb-t";
export var showSignatureButton = "_kb-u";
export var spinner = "_kb-v";
export var verticalButtonDivider = "_kb-4";
export var visibilitySelector = "_kb-w";
export var warning = "_kb-x";
export var wrappingText = "_kb-z";
export var writingInternalNoteTopBorder = "_kb-10";